import ConfigManager from '@/config/ConfigManager';
import BzbsApi from '@/core/Http/BzbsApi.js';
import Util from "@/helper/Utility.js";
import TransferPointConfig from './TransferPointConfigManager';

export default {
    getBaseUrl: function (apiPrefix) {
        var baseUrl = ConfigManager.getApiUrl();
        if (apiPrefix) {
            baseUrl = ConfigManager.getApiUrlWithPrefix.replace('{prefix}', apiPrefix);
        }
        return baseUrl;
    },
    postCheck: function (appMain, token, query, apiPrefix, weblandingBlob, jwt) {
        // console.log(TransferPointConfig.config(appMain))
        var baseUrl = this.getBaseUrl(apiPrefix);
        var url;
        // console.log(appMain + "_check")
        url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, appMain + "_check");
        // Util.log("url>> ", url);
        if (!url) {
            url = `${baseUrl}${TransferPointConfig.config(appMain).checkUrl}`;
            console.log("url", `${baseUrl}${TransferPointConfig.config(appMain).checkUrl}`)
        }

        var params = {

        }

        if (query) {
            params.query = query;
        }
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(url, token, params, jwt).subscribe({
                next: (res) => {
                    resolve(res.data)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    },
    // redeem
    convertPoint: function (appMain, token, tranId, appName, apiPrefix, extParam, weblandingBlob, points, jwt) {
        var baseUrl = this.getBaseUrl(apiPrefix);
        var url;

        var path = this.getApiConvertPoint(appMain, appName);
        if (path) {
            url = `${baseUrl}${path}`;
        }
        else {
            url = Util.getApiUrlFromWeblandingBlob(weblandingBlob, appMain + "_redeem");
        }
        //default
        if (!url) {
            var pathDefault = TransferPointConfig.config(appMain).redeemUrl;
            url = `${baseUrl}${pathDefault}`;
        }

        var params = {
            tranid: tranId,
            points
        }

        if (extParam) {
            for (var key in extParam) {
                params[key] = extParam[key];
            }
        }

        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(url, token, params, jwt).subscribe({
                next: (res) => {
                    resolve(res)
                },
                error: (err) => {
                    reject(err)
                }
            })
        })
    },
    getApiConvertPoint: function (appMain, appName) {
        var pathSpecial = TransferPointConfig.config(appMain).redeemUrlSpecial[appName];
        if (!Util.isEmptyStr(pathSpecial)) {
            return pathSpecial;
        }

        return;
    },
}
